import api from "api"
import { Product } from "api/resources/users/types"
import FullPageLoading from "components/FullPageLoading"
import { useEffect, useState } from "react"
import { Outlet } from "react-router-dom"
import { clearAuthInfo, getAuthInfo } from "utils/auth"
const GlobalAuthObserver = () => {
  const [authIsValid, setAuthIsValid] = useState<boolean>(false)

  useEffect(() => {
    const checkAuth = async () => {
      const authInfo = getAuthInfo()
      try {
        if (authInfo) {
          const res = await api.users.getUser()
          if (res.product !== Product.internal) {
            clearAuthInfo()
            window.location.reload()
            return
          }

          setAuthIsValid(true)
        }
      } catch (e) {
        console.log("> Access token is invalid", e)
      }
    }

    if (getAuthInfo()) {
      checkAuth()
    } else {
      setAuthIsValid(true)
    }
  }, [])

  return (
    <>
      {!authIsValid && <FullPageLoading />}
      {authIsValid && <Outlet />}
    </>
  )
}

export default GlobalAuthObserver
